import { render, staticRenderFns } from "./DashboardCanvas.vue?vue&type=template&id=18f2daea"
import script from "./DashboardCanvas.vue?vue&type=script&lang=js"
export * from "./DashboardCanvas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports